// extracted by mini-css-extract-plugin
export default {"name_message":"styles_name_message__b-0+f","clickable":"styles_clickable__GwPin","nonClickable":"styles_nonClickable__LNczL"};